// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ac-4";
export var closeButton = "_ac-6";
export var dismissButton = "_ac-3";
export var editImageWithAiContainer = "_ac-8";
export var imageUploadWrapper = "_ac-7";
export var misspelledWord = "_ac-5";
export var spellCheckContainer = "_ac-2";
export var spin = "_ac-1";
export var spinning = "_ac-0";